import Upload from './upload';

export default Upload;
export type * from './types';
